var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppliedStatistics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFBC42;}\r\n\t.st1{fill:#FF6B6B;}\r\n\t.st2{fill:#DBE9EE;}\r\n\t.st3{fill:#33658A;}\r\n\t.st4{fill:#33B9EF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -280.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path17032",
    vectorEffect: "none",
    className: "st0",
    d: "M53.3,303.4c-7.4,0-13.3,6-13.3,13.3c0,7.4,6,13.3,13.3,13.3 s13.3-6,13.3-13.3c0-0.5-0.4-0.8-0.8-0.8H54.2v-11.7C54.2,303.8,53.8,303.4,53.3,303.4L53.3,303.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17036",
    vectorEffect: "none",
    className: "st1",
    d: "M56.6,300.1c-0.4,0-0.8,0.4-0.8,0.8v12.5c0,0.5,0.4,0.8,0.8,0.8 c0,0,0,0,0,0h12.5c0.5,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0C70,306,64,300.1,56.6,300.1C56.6,300.1,56.6,300.1,56.6,300.1L56.6,300.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9804",
    vectorEffect: "none",
    className: "st2",
    d: "M50,321.7c-0.5,0-0.8,0.4-0.8,0.8v11.7c0,0.5,0.4,0.8,0.8,0.8 s0.8-0.4,0.8-0.8v-11.7C50.8,322.1,50.5,321.7,50,321.7C50,321.7,50,321.7,50,321.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9806",
    vectorEffect: "none",
    className: "st2",
    d: "M62.5,305.1c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8c0,0,0,0,0,0 H80v2.5c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0v-3.3c0-0.5-0.4-0.8-0.8-0.8c0,0,0,0,0,0H62.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path9808",
    vectorEffect: "none",
    className: "st3",
    d: "M45.8,338.4c-1.1,0-1.1,1.7,0,1.7h10c1.1,0,1.1-1.7,0-1.7H45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9810",
    vectorEffect: "none",
    className: "st3",
    d: "M42.5,343.4h8.3c1.1,0,1.1-1.7,0-1.7h-8.4 C41.3,341.8,41.4,343.5,42.5,343.4L42.5,343.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9812",
    vectorEffect: "none",
    className: "st3",
    d: "M42.5,346.7h13.3c1.1,0,1.1-1.7,0-1.7H42.5 C41.3,345.1,41.4,346.8,42.5,346.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9814",
    vectorEffect: "none",
    className: "st3",
    d: "M54.2,343.4h1.7c1.1,0,1.1-1.7,0-1.7h-1.7 C53,341.8,53.1,343.5,54.2,343.4L54.2,343.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9816",
    vectorEffect: "none",
    className: "st3",
    d: "M47.5,350.1h8.3c1.1,0,1.1-1.7,0-1.7h-8.4 C46.3,348.5,46.4,350.1,47.5,350.1L47.5,350.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9818",
    vectorEffect: "none",
    className: "st3",
    d: "M42.5,350.1h1.7c1.1,0,1.1-1.7,0-1.7h-1.7 C41.3,348.5,41.4,350.1,42.5,350.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9820",
    vectorEffect: "none",
    className: "st3",
    d: "M84.5,330.2l-6.3,4.8l-6.7-1.7l-7,5.2l1,1.3l6.3-4.8l6.7,1.7l7-5.2 L84.5,330.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path17058",
    vectorEffect: "none",
    className: "st4",
    d: "M63.3,343.4c-0.5,0-0.8,0.4-0.8,0.8v5h5v-5c0-0.5-0.4-0.8-0.8-0.8H63.3z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17062",
    vectorEffect: "none",
    className: "st4",
    d: "M70,340.1c-0.5,0-0.8,0.4-0.8,0.8v8.3h5v-8.3c0-0.5-0.4-0.8-0.8-0.8H70z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17066",
    vectorEffect: "none",
    className: "st4",
    d: "M76.7,341.7c-0.5,0-0.8,0.4-0.8,0.8v6.7h5v-6.7c0-0.5-0.4-0.8-0.8-0.8 H76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17070",
    vectorEffect: "none",
    className: "st4",
    d: "M83.3,336.7c-0.5,0-0.8,0.4-0.8,0.8v11.7h5v-11.7c0-0.5-0.4-0.8-0.8-0.8 H83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17074",
    vectorEffect: "none",
    className: "st0",
    d: "M65,336.7c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5 c1.4,0,2.5-1.1,2.5-2.5S66.4,336.7,65,336.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17078",
    vectorEffect: "none",
    className: "st0",
    d: "M71.7,331.7c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5 c1.4,0,2.5-1.1,2.5-2.5C74.2,332.9,73,331.7,71.7,331.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17082",
    vectorEffect: "none",
    className: "st0",
    d: "M78.3,333.4c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5 s2.5-1.1,2.5-2.5C80.8,334.5,79.7,333.4,78.3,333.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17086",
    vectorEffect: "none",
    className: "st0",
    d: "M85,328.4c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5 s2.5-1.1,2.5-2.5C87.5,329.5,86.4,328.4,85,328.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9838",
    vectorEffect: "none",
    className: "st3",
    d: "M60.8,350.1h28.3c1.1,0,1.1-1.7,0-1.7H60.8 C59.6,348.5,59.7,350.1,60.8,350.1L60.8,350.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9884",
    vectorEffect: "none",
    className: "st3",
    d: "M77.5,313.4c-1.1,0-1.1,1.7,0,1.7h10c1.1,0,1.1-1.7,0-1.7H77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9886",
    vectorEffect: "none",
    className: "st3",
    d: "M74.2,318.4h8.3c1.1,0,1.1-1.7,0-1.7h-8.4 C73,316.8,73.1,318.5,74.2,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9888",
    vectorEffect: "none",
    className: "st3",
    d: "M74.2,321.7h13.3c1.1,0,1.1-1.7,0-1.7H74.1 C73,320.1,73.1,321.8,74.2,321.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9890",
    vectorEffect: "none",
    className: "st3",
    d: "M85.8,318.4h1.7c1.1,0,1.1-1.7,0-1.7h-1.7 C84.6,316.8,84.7,318.5,85.8,318.4L85.8,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9892",
    vectorEffect: "none",
    className: "st3",
    d: "M79.2,325.1h8.3c1.1,0,1.1-1.7,0-1.7h-8.4 C78,323.5,78.1,325.1,79.2,325.1L79.2,325.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9894",
    vectorEffect: "none",
    className: "st3",
    d: "M74.2,325.1h1.7c1.1,0,1.1-1.7,0-1.7h-1.7 C73,323.5,73.1,325.1,74.2,325.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedStatistics);
export default __webpack_public_path__ + "static/media/AppliedStatistics.1ab81922526b7b2a898623e9917ba4e9.svg";
export { ForwardRef as ReactComponent };